import React, { useState, useEffect } from "react";
import axios from "axios";
import GallerySlider from "./components/Gallery/GallerySlider";
import BusinessEnquiry from "./components/Forms/Enquiry";
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";
import Breadcrumbs from './components/BreadCrumb/Index'

const GalleryPage = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/home.php`);
        setHomeData(response.data);
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  if (!homeData) return null;

  const {
    gallery,
    corporate_brochure,
  } = homeData;

  return (
    <main>
      <Breadcrumbs />
      <GallerySlider Data={gallery} />
      <BusinessEnquiry corporate_brochure={corporate_brochure}/>     
    </main>
    
  );
};

export default GalleryPage;
